
import { GET_WATCH_LISTS } from '../types';
import createAsyncActions from '../utilities/createAsyncActions';

export const {
  getWatchLists,
  getWatchListsPending,
  getWatchListsFulfilled,
  getWatchListsRejected,
} = createAsyncActions(GET_WATCH_LISTS, 'getWatchLists');


// WEBPACK FOOTER //
// ./src/actions/getWatchListsActions.js